import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { Helper } from '../../../../../pages/common/helper';
import swal from 'sweetalert2';
import { UserLogin } from '../../../../../pages/security/model/userLogin';
import { LoginService } from '../../../../../pages/login/login.service';
import { SecurityHelper } from '../../../../../pages/common/securityHelper';
import { UserSession } from '../../../../../pages/security/model/userSession';
import { OnlineOfflineService } from '../../../../../services/online-offline.service';
import { UserNotificationData } from '../../../../../pages/notification/Model/user-notification';
import { SecurityService } from '../../../../../pages/security/service/security.service';
import { CommonService } from '../../../../../services/common.service';
import { Subscription } from 'rxjs';
import { ShipData } from '../../../../../pages/info/model/ship-info';
import { AppSettings } from '../../../../../pages/maintenance/model/appSettings';
import { WebStorage } from '../../../../../pages/common/webStorage';

@Component({
  standalone: false,
  selector: 'app-nav-right',
  templateUrl: './nav-right.component.html',
  styleUrls: ['./nav-right.component.scss'],
  providers: [NgbDropdownConfig]
})
export class NavRightComponent implements OnInit {

  public logoPath!: string;

  public notificationCount: number = 0;

  public unableToLoadImage: boolean = false;
  public fullName: string = '';
  public fullNameInitial: string = '';
  public displayPictureFilePath: string = '';

  public userNotificationList: any[] = [];

  public isDataReady: boolean = true;

  public displayOrderHandlerName: string = '';
  public displayOrderHandlerImageUrl: string = '';
  public displayOrderHandlerEmail: string = '';
  public displayOrderHandlerContactNumber: string = '';

  shipInfo: ShipData = new ShipData();

  //user Image
  public userImageDirectoryPath: string = '';
  //Blob
  blobUrl: string = '';

  public imageFilePath!: string;

  unableToLoadOrderHandlerImage: boolean = false;
  fullNameInitialOrderHandler: string = '';

  @Output() onNavToggleChat = new EventEmitter();

  constructor(
    private router: Router,
    private loginService: LoginService,
    private securityService: SecurityService,
    readonly onlineOfflineService: OnlineOfflineService,
    private commonService: CommonService,
  ) {

  }

  ngOnInit() {

    this.subscriptions.push(this.commonService.onLoadUserNotification.subscribe((caller: string) => this.loadUserNotification(caller)));

    this.isDataReady = true;

    let user: UserLogin = SecurityHelper.GetLoggedInUserData();

    // get logged-in user's picture
    if (user.roleID != null) {
      this.fullName = (user.username).trim();
      if (user.roleID == Helper.Constants.RoleID.COOK)
        this.displayPictureFilePath = 'assets/images/user/chef-hat.jpg';
      if (user.roleID == Helper.Constants.RoleID.CAPTAIN)
        this.displayPictureFilePath = 'assets/images/user/captain-hat.jpg';
    }

    // get logged-in user's initial - display if picture is not available
    let split = this.fullName.split(' ');
    let char1 = split[0].charAt(0);
    let char2 = (split.length > 1) ? split[split.length - 1].charAt(0) : '';
    this.fullNameInitial = char1 + char2;

    // get user notifications
    this.getUserNotificationList(SecurityHelper.GetLoggedInUserData().userID);

    this.getBlobUrl();
    this.getUserImageBlob();
    this.getShipManagerLogoDirectoryPath();
    this.getShipOrderHandlerInfo();

  }

  getBlobUrl() {
    if (this.onlineOfflineService.isOnline) {
      this.securityService.getBlobUrl().subscribe({
        next: (res: any) => {
          if (this.isResponseValid(res)) {
            let appSettings: AppSettings[] = res.entity.list;
            this.blobUrl = appSettings[0].settingValue;
          }
        },
        error: (err: any) => this.handleError(err)
      });
    }
  }
  getUserImageBlob() {
    if (this.onlineOfflineService.isOnline) {
      this.securityService.getUserImageBlobPath().subscribe({
        next: (res: any) => {
          if (this.isResponseValid(res)) {
            let appSettings: AppSettings[] = res.entity.list;
            this.userImageDirectoryPath = appSettings[0].settingValue;
          }
        },
        error: (err: any) => this.handleError(err)
      });
    }
  }

  loadUserNotification(caller: string) {
    if (caller) {
      if (this.onlineOfflineService.isOnline && this.onlineOfflineService.isAuthenticated) {
        // get user notifications
        this.getUserNotificationList(SecurityHelper.GetLoggedInUserData().userID);
      }
    }
  }

  subscriptions: Subscription[] = [];
  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe())
  }

  logout() {

    if (this.onlineOfflineService.isOnline && !SecurityHelper.IsHTTPRequestsUnathorized(false)) {
      this.loginService.logOut().subscribe({
        complete: () => {

          let userName = SecurityHelper.GetLoggedInUserData().username;
          this.securityService.saveIsAuthenticated(userName, false);
          SecurityHelper.GoBackToLoginPage();
        }
      });
    }
    else {

      SecurityHelper.GoBackToLoginPage();
    }
  }

  onImageError(event: any) {
    this.unableToLoadImage = true;
  }

  getUserNotificationList(userID: number): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      if (this.onlineOfflineService.isOnline && this.onlineOfflineService.isAuthenticated) {
        this.loginService.getUserNotificationList(userID).pipe().subscribe(
          (res: any) => {
            if (this.isResponseValid(res)) {
              this.loginService.saveUserNotificationIndexDb(res.entity.list)
              this.getNavigationList(res.entity.list);
              resolve(this.userNotificationList)
            }
          });
      } else {
        this.loginService.getUserNotificationIndexDb().then((notifList: any) => {
          this.getNavigationList(notifList);
          resolve(this.userNotificationList.sort(function (a, b) {
            var dateA: any = new Date(a.createTime), dateB: any = new Date(b.createTime);
            return dateB - dateA;
          }));
        });
      }
    });
    return promise;
  }

  private assignNotificationIcon() {
    this.userNotificationList.forEach((notif: UserNotificationData) => {
      switch (notif.userNotificationTypeID) {
        case Helper.Constants.UserNotificationType.FOLLOWUP:
          notif.userNotificationTypeIcon = 'fa fa-exclamation-circle';
          break;
        default:
          notif.userNotificationTypeIcon = 'fa fa-envelope-open';
          break;
      }

      switch (notif.requestModule) {
        case Helper.Constants.RequestModules.ORDER:
          notif.userNotificationTypeIconColor = 'notif-bg-order';
          notif.userNotificationTypeIcon = 'feather icon-shopping-cart';
          break;
        case Helper.Constants.RequestModules.BEGIN_AND_END_STOCK:
          notif.userNotificationTypeIconColor = 'notif-bg-stocks';
          notif.userNotificationTypeIcon = 'fa fa-book-open';
          break;
        case Helper.Constants.RequestModules.DAILY_MEALS:
          notif.userNotificationTypeIconColor = 'notif-bg-dailymeals';
          notif.userNotificationTypeIcon = 'feather icon-clipboard';
          break;
        case Helper.Constants.RequestModules.CLAIM:
          notif.userNotificationTypeIconColor = 'notif-bg-claim';
          notif.userNotificationTypeIcon = 'fa fa-meh';
          break;
      }
    });
  }

  onDeleteNotification(data: UserNotificationData) {
    if (this.onlineOfflineService.isOnline && this.onlineOfflineService.isAuthenticated) {
      this.loginService.deleteUserNotification(data).pipe().subscribe(
        (res: any) => {
          if (this.isResponseValid(res)) {
            this.loginService.deleteUserNotificationIndexDb(data);
            this.removeNotificationFromList(data);
            this.getNavigationCount(this.userNotificationList);
          }
        }
      );
    } else {
      this.loginService.markDeleteUserNotificationIndexDb(data);
      this.loginService.deleteUserNotificationIndexDb(data);
      this.removeNotificationFromList(data);
      this.getNavigationCount(this.userNotificationList);
    }
  }

  private getNavigationList(notifList: UserNotificationData[]) {
    this.userNotificationList = notifList;
    this.getNavigationCount(this.userNotificationList);
    this.assignNotificationIcon();
  }
  private getNavigationCount(notifList: UserNotificationData[]) {
    this.notificationCount = notifList.length;
  }
  private removeNotificationFromList(data: UserNotificationData) {
    let index = this.userNotificationList.indexOf(data);
    this.userNotificationList.splice(index, 1);
  }

  onRespondNotification(data: any) {

    // Note: Navigating to same url will not reload the component. Workaround fix, navigate to a diff url first.
    this.router.navigateByUrl('/admin/home', { skipLocationChange: true }).then(() => {

      this.router.navigate(['/admin/notification/notif-messaging']);
      WebStorage.SessionStorage.SetQueryParams(JSON.stringify({ notificationId: data.notificationID }));
    });
  }

  workOffline() {
    let appOffline = SecurityHelper.GetWorkOffline();

    this.onlineOfflineService.toggleOfflineMode(!appOffline);

    SecurityHelper.SetWorkOffline(!appOffline);
  }

  refresh() {

    this.isDataReady = false;

    // get user notifications
    this.getUserNotificationList(SecurityHelper.GetLoggedInUserData().userID).then(() => {
      setTimeout(() => {
        this.isDataReady = true;
      }, 500);
    });

  }

  goToChangePassword() {
    if (this.onlineOfflineService.isOnline && this.onlineOfflineService.isAuthenticated) {
      this.router.navigate(['/changePassword']);
    } else {
      this.onlineOfflineService.showOfflineWarning();
    }
  }

  goToRegisterShipCrew() {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.router.navigate(['admin', 'maintenance', 'ship-crew-reg']);
  }
  // Common
  getShipOrderHandlerInfo() {

    let shipID = SecurityHelper.GetLoggedInUserData().shipID;
    // console.log(shipID);

    this.unableToLoadOrderHandlerImage = false;
    if (this.onlineOfflineService.isOnline) {
      this.securityService.getShipDetails().subscribe((res: any) => {
        if (res.entity.list != null) {
          let details: ShipData[] = res.entity.list;
          if (details.length > 0) {
            this.securityService.saveShipDetailsIndxDb(details[0]);

            var shipOrderHandlerID;
            this.shipInfo = details[0];
            if (this.shipInfo.weekendOrderHandlerID != 0) {
              this.displayOrderHandlerName = this.shipInfo.weekendOrderHandler
              this.displayOrderHandlerEmail = this.shipInfo.emailSenderEmail
              this.displayOrderHandlerContactNumber = this.shipInfo.weekendOrderHandlerMobile
              shipOrderHandlerID = this.shipInfo.weekendOrderHandlerID;
            }
            else if (this.shipInfo.isBackupOrderHandlerActive) {
              this.displayOrderHandlerName = this.shipInfo.backupOrderHandler
              this.displayOrderHandlerEmail = this.shipInfo.emailSenderEmail
              this.displayOrderHandlerContactNumber = this.shipInfo.backupOrderHandlerMobile
              shipOrderHandlerID = this.shipInfo.backupOrderHandlerID;
            }
            else {
              this.displayOrderHandlerName = this.shipInfo.shipOrderHandler
              this.displayOrderHandlerEmail = this.shipInfo.emailSenderEmail
              this.displayOrderHandlerContactNumber = this.shipInfo.shipOrderHandlerMobile
              shipOrderHandlerID = this.shipInfo.shipOrderHandlerID
            }
            // get logged-in user's initial - display if picture is not available
            let split = this.displayOrderHandlerName.split(' ');
            let char1 = split[0].charAt(0);
            let char2 = (split.length > 1) ? split[split.length - 1].charAt(0) : '';
            this.fullNameInitialOrderHandler = char1 + char2;

            this.securityService.getUserByContactID(shipOrderHandlerID).subscribe(
              (res: any) => {
                let userDetails = res.entity.list;
                if (userDetails.length > 0) {

                  if (userDetails[0].userImageFile != null) {
                    const imageFilePathTmp = this.userImageDirectoryPath + userDetails[0].userImageFile;
                    let indx = imageFilePathTmp.indexOf('users-files');
                    let userBlobfilesPath = imageFilePathTmp.substring(indx);
                    this.imageFilePath = imageFilePathTmp;
                    this.securityService.isBlobfileExist(userBlobfilesPath).subscribe(
                      (res: any) => {
                        if (this.isResponseValid(res)) {
                          if (res.entity.value == 'true') {
                            // this.checkIfUserImageExist(this.imageFilePath);
                            if (this.onlineOfflineService.isOnline) {
                              this.imageFilePath = this.imageFilePath;
                            }
                            else {
                              this.unableToLoadOrderHandlerImage = true;
                            }

                          }
                          else {
                            this.unableToLoadOrderHandlerImage = true;
                          }
                        }
                      },
                      (err: any) => this.handleError(err));
                  }
                  else {
                    this.unableToLoadOrderHandlerImage = true;
                  }
                }
              });

            //save contact info to local storage
            this.SetShipContact(this.displayOrderHandlerName, this.displayOrderHandlerEmail, this.displayOrderHandlerContactNumber);
          }
        }
        else {
          this.unableToLoadOrderHandlerImage = true;
        }
      });
    }
    else {
      this.securityService.getShipDetailsIndxDb(shipID).then((res: any) => {
        this.shipInfo = res;
        this.displayOrderHandlerName = this.shipInfo.shipOrderHandler
        this.displayOrderHandlerEmail = this.shipInfo.emailSenderEmail
        this.displayOrderHandlerContactNumber = this.shipInfo.shipOrderHandlerMobile
        // get logged-in user's initial - display if picture is not available
        let split = this.displayOrderHandlerName.split(' ');
        let char1 = split[0].charAt(0);
        let char2 = (split.length > 1) ? split[split.length - 1].charAt(0) : '';
        this.fullNameInitialOrderHandler = char1 + char2;
        this.unableToLoadOrderHandlerImage = true;
      })
    }

  }

  private SetShipContact(name: any, email: any, contactNumber: any) {
    let contact = {
      'name': name,
      'email': email,
      'contactNumber': contactNumber,
    }
    SecurityHelper.SetShipContact(contact);
  }

  getShipManagerLogoDirectoryPath() {
    if (this.onlineOfflineService.isOnline) {
      this.securityService.getShipManagerLogoDirectoryPath().subscribe((res: any) => {
        if (res.entity.list != null) {
          let indx = res.entity.list[0].path.indexOf('users-files');
          let onlinePath = res.entity.list[0].path;

          this.logoPath = res.entity.list[0].path.substring(indx);

          SecurityHelper.SetShipManagerLogo(this.logoPath);
          // this.checkIfImageExist(onlinePath);

          this.securityService.isBlobfileExist(this.logoPath).subscribe({
            next: (res: any) => {
              if (this.isResponseValid(res)) {
                if (res.entity.value == 'true') {
                  this.logoPath = onlinePath;
                }
                else {
                  this.logoPath = 'assets/images/no-image-available.png';
                }
              }
            },
            error: (err: any) => this.handleError(err)
          });

        }
        else {
          this.logoPath = 'assets/images/no-image-available.png';
        }
      });
    }
    else {
      let path = SecurityHelper.GetShipManagerLogo();
      this.logoPath = path;
      this.checkIfImageExist(path);
    }
  }
  checkIfUserImageExist(onlinePath: any) {
    fetch(this.imageFilePath, { method: 'HEAD' })
      .then((res: any) => {
        if (res.ok) {
          if (this.onlineOfflineService.isOnline) {
            this.imageFilePath = onlinePath;
          }
        }
        else {
          this.unableToLoadOrderHandlerImage = true;
        }
      }).catch((err: any) => {
        this.unableToLoadOrderHandlerImage = true;
      });
  }
  checkIfImageExist(onlinePath: any) {
    fetch(this.logoPath, { method: 'HEAD' })
      .then((res: any) => {
        if (!res.ok) {
          if (this.onlineOfflineService.isOnline) {
            this.logoPath = onlinePath;
          }
        }
      }).catch((err: any) => {
        this.logoPath = 'assets/images/no-image-available.png';
        console.log('Error:', err)
      });
  }

  handleError(error: any) {
    let errorTitle = error.name ? error.name : 'Error';
    let errorMessage = error.message ? error.message : JSON.stringify(error);

    swal.fire({
      title: errorTitle,
      html: '<span>' + errorMessage + '</span>',
      icon: "error",
      showCloseButton: true,
      allowOutsideClick: false,
      allowEscapeKey: false
    });
  }

  isResponseValid(res: any): boolean {
    let isValid = true;

    if (res.errorMessage.length > 0) {
      isValid = false;
      this.handleError(res.errorMessage[0]);
    }

    return isValid;
  }

  public navToggleChat() {
    this.onNavToggleChat.emit();
  }
}
